import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import botspotLogo from '../../assets/botspot_logo_horizontal.png';
import './AlpacaMobileReturnFallback.css';

export default function AlpacaMobileReturnFallback() {
  return (
    <main className="alpaca-mobile-return" data-testid="alpaca-mobile-return">
      <Helmet>
        <title>Return to BotSpot</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="alpaca-mobile-return__content">
        <img
          alt="BotSpot by LumiWealth"
          className="alpaca-mobile-return__logo"
          src={botspotLogo}
        />
        <div className="alpaca-mobile-return__status" aria-hidden="true">
          <span />
        </div>
        <h1>Return to BotSpot</h1>
        <p>
          This Alpaca sign-in link must finish in the BotSpot app. Return to
          BotSpot now. If setup did not continue, retry Alpaca sign-in from the
          app.
        </p>
        <p className="alpaca-mobile-return__privacy">
          No brokerage authorization details are shown on this page.
        </p>
        <Link className="alpaca-mobile-return__support" to="/contact">
          Contact support
        </Link>
      </div>
    </main>
  );
}
